import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useStudentsService } from '../../../../apis/students/useStudentsService';
import {
  IStudentListQueryParams,
  TStudentListApiResponse,
} from '../../../../apis/students/students.interfaces';

type TQueryError = IFHError<{ message: string }>;
type TStudentListQueryOptions = Omit<
  UseQueryOptions<TStudentListApiResponse, TQueryError>,
  'queryKey' | 'queryFn'
>;

export const getStudentListKey = 'get-student-list';

export const useStudentListHook = (
  params: IStudentListQueryParams,
  options?: TStudentListQueryOptions
): UseQueryResult<TStudentListApiResponse, TQueryError> => {
  const { getStudentList } = useStudentsService();
  const { enabled = true, ...queryOptions } = options ?? {};

  return useQuery<TStudentListApiResponse, TQueryError>({
    queryKey: [getStudentListKey, params],
    queryFn: () => getStudentList(params),
    ...queryOptions,
    enabled,
  });
};
